import { Input } from '@angular/core';
import { AfterViewInit, OnDestroy, Component } from '@angular/core';
import { ControlContainer, FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-basic-time-picker',
  templateUrl: './basic-time-picker.component.html',
  styleUrl: './basic-time-picker.component.css'
})
export class BasicTimePickerComponent implements AfterViewInit, OnDestroy {
  hourlyList: any[] = [
  { name: "Select", hourValue: 0, minValue: 0},
  { name: "2 Minutes", hourValue: 0, minValue: 2 },
  { name: "5 Minutes", hourValue: 0, minValue: 5 },
  { name: "10 Minutes", hourValue: 0, minValue: 10 },
  { name: "15 Minutes", hourValue: 0, minValue: 15 },
  { name: "30 Minutes", hourValue: 0, minValue: 30 },
  { name: "1 Hour", hourValue: 1, minValue: 0 },
  { name: "2 Hours", hourValue: 2, minValue: 0 },
  { name: "3 Hours", hourValue: 3, minValue: 0 },
  { name: "4 Hours", hourValue: 4, minValue: 0 },
  { name: "5 Hours", hourValue: 5, minValue: 0 },
  { name: "6 Hours", hourValue: 6, minValue: 0 },
  { name: "7 Hours", hourValue: 7, minValue: 0 },
  { name: "8 Hours", hourValue: 8, minValue: 0 },
  { name: "9 Hours", hourValue: 9, minValue: 0 },
  { name: "10 Hours", hourValue: 10, minValue: 0 },
  { name: "11 Hours", hourValue: 11, minValue: 0 },
  { name: "12 Hours", hourValue: 12, minValue: 0 },
  { name: "13 Hours", hourValue: 13, minValue: 0 },
  { name: "14 Hours", hourValue: 14, minValue: 0 },
  { name: "15 Hours", hourValue: 15, minValue: 0 },
  { name: "16 Hours", hourValue: 16, minValue: 0 },
  { name: "17 Hours", hourValue: 17, minValue: 0 },
  { name: "18 Hours", hourValue: 18, minValue: 0 },
  { name: "19 Hours", hourValue: 19, minValue: 0 },
  { name: "20 Hours", hourValue: 20, minValue: 0 },
  { name: "21 Hours", hourValue: 21, minValue: 0 },
  { name: "22 Hours", hourValue: 22, minValue: 0 },
  { name: "23 Hours", hourValue: 23, minValue: 0 }];

  internalGroup: FormGroup;
  private _subscriptions = new Subscription();
  private _logChange: boolean = true;

  constructor(public parent: ControlContainer) {
    this.internalGroup = new FormGroup({
      selection: new FormControl(5),
    });
  }

  ngOnDestroy() {
    this._subscriptions.unsubscribe();
  }

  ngAfterViewInit(): void {
    Promise.resolve(null).then(() => {
      this.calculateSelection();
      this.subscribeToChange();
    });
  }

  get control(): FormGroup {
    return this.parent.control as FormGroup;
  }

  @Input()
  get disabled(): boolean {
    return this.internalGroup.controls.selection.disabled;
  }
  set disabled(value: boolean) {
    if (value) {
      this.internalGroup.controls.selection.disable();
    }
    else {
      this.internalGroup.controls.selection.enable();
    }
  }

  @Input()
  get label(): string {
    return this._label;
  }
  set label(value: string) {
    this._label = value;
  }
  private _label: string = "Time";

  calculateSelection() {
    let hours = this.control.controls.hours.value;
    let minutes = this.control.controls.minutes.value;
    for (let i = 0; i < this.hourlyList.length; i++) {
      if (this.hourlyList[i].hourValue == hours && this.hourlyList[i].minValue == minutes) {
        this.internalGroup.controls.selection.setValue(i);
        return;
      }
    }

    if (minutes != 0) {
      for (let i = 0; i < this.hourlyList.length; i++) {
        if (this.hourlyList[i].minValue == minutes) {
          this.internalGroup.controls.selection.setValue(i);
          break;
        }
      }
    }
  }

  subscribeToChange() {
    this._subscriptions.add(
      this.internalGroup.valueChanges.subscribe((value) => {
        if (value.selection != null) {
          this._logChange = false;
          this.control.controls.hours.setValue(this.hourlyList[value.selection].hourValue);
          this.control.controls.minutes.setValue(this.hourlyList[value.selection].minValue);
          this._logChange = true;
        }
      }));
  }
}
